import axios from "axios";
import { attachAcceptLanguage } from "../interceptors/attach-accept-language";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { attachAccessToken } from "../interceptors/attach-access-token";
import { attachOrganizationToken } from "../interceptors/attach-organization-token";
import { refreshAccessTokenLogic } from "../interceptors/refresh-access-token-logic";

const orgApiV4 = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/organization-admin-api/v4`,
});

createAuthRefreshInterceptor(orgApiV4, refreshAccessTokenLogic);

orgApiV4.interceptors.request.use(attachAccessToken);
orgApiV4.interceptors.request.use(attachOrganizationToken);
orgApiV4.interceptors.request.use(attachAcceptLanguage);

export default orgApiV4;
